module.exports = __webpack_public_path__ + "4abb71f4d41b85bc0911bee6f6ba0dc6.woff";